// extracted by mini-css-extract-plugin
export var active = "languageSwitch-module--active--VVQ+M";
export var container = "languageSwitch-module--container--QvdoC";
export var dropdown = "languageSwitch-module--dropdown--mi7DT";
export var lang = "languageSwitch-module--lang--IMsFf";
export var languageSwitch = "languageSwitch-module--languageSwitch--IMGH9";
export var sbShowMain = "languageSwitch-module--sb-show-main--h9PH5";